<template>
  <div class="BusanEvent">
    <div>
      <img width="100%" src="@/assets/img/event/img_main_visual.png" />
    </div>
    <div
      class="BusanEvent__privacy"
      v-for="(privacy, index) in getPrivacy"
      :key="`${privacy.type}-${index}`"
    >
      <div class="privacy-checkbox">
        <input
          :id="`privacy${privacy.type}`"
          v-model="privacy.checked"
          type="checkbox"
        />
        <label :for="`privacy${privacy.type}`">
          <img
            width="32px"
            :src="
              require(`@/assets/img/event/ic_${
                privacy.checked ? 'checked' : 'check'
              }.jpg`)
            "
          />
          {{ privacy.title }}<span>(필수)</span>
        </label>
      </div>
      <div class="description" v-html="nl2br(privacy.description)"></div>
    </div>
    <div class="BusanEvent__notice">
      <div class="title">유의사항</div>
      <ul class="notices">
        <li v-for="(notice, notiIndex) in notices" :key="notiIndex">
          <div>{{ notice }}</div>
        </li>
      </ul>
    </div>
    <div class="BusanEvent__submit">
      <button type="button" :disabled="isSubmitDisabled" @click="submit()">
        가입하고 혜택받기
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BusanEvent",
  data() {
    return {
      getPrivacy: [
        {
          type: "information",
          checked: false,
          title: "개인정보 수집 이용 동의",
          description:
            "<b>1. 개인정보 수집 이용 동의</b>\n\n㈜한국디지털거래소는 신규가입 이벤트 진행을 위해 아래와 같이 개인정보를 수집/이용하는 내용을 관련 법령에 따라 고지하오니 동의해주시기 바랍니다.\n\n수집/이용 항목 : 성명, 연락처(전화번호)\n수집/이용 목적 : 수집된 개인정보는 위 이벤트 참여 및 당첨자 경품 제공 등을 위해 활용됩니다.\n이벤트 경품은 모바일 쿠폰 형태로 발송되며, 경품배송을 위하여 개인정보(휴대폰번호)가 이벤트 상품발송 대행업체에게 제공되며 제공목적 달성 후 폐기됩니다.\n\n※ 이벤트 참여고객은 개인정보 수집, 이용에 대하여 동의를 거부 할 권리를 가지고 있으며, 개인정보 수집, 이용에 대한 미동의 시 이벤트에 참여하실 수 없습니다.",
        },
        {
          type: "tirdParty",
          checked: false,
          title: "개인정보 처리 위탁 동의",
          description:
            "<b>2. 개인정보 처리 위탁 동의</b>\n\n개인정보를 제공받는 자 : ㈜케이티알파 (기프티쇼)\n이용 항목 : 성명, 연락처(전화번호)\n이용 목적 : 모바일 쿠폰 발송\n보유 기간 : 상품권 다운로드 기간 종료 후 90일까지\n*경품 발송은 ㈜한국디지털거래소에서 진행합니다.\n\n※ 이벤트 참여고객은 개인정보 처리 위탁에 대한 동의를 거부 할 권리를 가지고 있으며, 개인정보 처리 위탁에 대한 미동의 시 이벤트에 참여하실 수 없습니다.",
        },
      ],
      notices: [
        "본 이벤트는 현재 페이지를 통해 가입 후 휴대폰 본인인증을 완료한 회원을 대상으로 진행됩니다.",
        "이벤트 기간 내 1인 1회만 참여가 가능합니다.",
        "평일 기준 3일 이내 등록한 휴대폰 번호로 모바일 쿠폰이 발송됩니다.",
        "본 이벤트는 당사 사정에 의해 변경 또는 조기 종료될 수 있습니다.",
        "부정한 방법으로 이벤트에 응모한 경우, 당첨자 선정에서 제외될 수 있으며 당첨 후에도 당첨이 취소될 수 있습니다.",
        "이벤트 관련 문의는 help@flybit.com 또는 홈페이지 우측 하단의 1:1 채팅으로 문의 바랍니다.",
      ],
      validationError: [],
    };
  },
  computed: {
    isSubmitDisabled() {
      this.validationError = [];

      this.getPrivacy.forEach((privacy) => {
        if (!privacy.checked) {
          this.validationError.push(privacy.type);
        }
      });

      return this.validationError.length ? true : false;
    },
  },
  methods: {
    submit() {
      if (this.isSubmitDisabled) {
        return this.$notify({
          title: "오류",
          message: "필수 동의사항을 동의해주셔야 이용가능합니다.",
          type: "warning",
          customClass: "dexko-noti",
          position: "top-left",
        });
      }

      // return location.assign("/member?invite=2000760");
      return location.assign("/member?invite=2032354");
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./font.css";

.BusanEvent {
  padding-bottom: 20px;

  &__privacy {
    padding: 0 9px;
    margin-bottom: 32px;

    .privacy-checkbox {
      display: flex;
      align-items: center;

      input {
        position: absolute;
        opacity: 0;
      }

      label {
        font-family: "GmarketSansBold";
        font-weight: bold;
        font-size: 14px;
        color: #000;
        display: flex;
        align-items: center;

        span {
          color: #eb3246;
          margin-left: 5px;
        }
      }

      img {
        margin-right: 5px;
      }
    }

    .description {
      font-size: 12px;
      color: #000;
      height: 184px;
      overflow-y: auto;
      border: 1px solid #dadada;
      border-radius: 8px;
      padding: 14px 10px;
      margin-top: 12px;
      word-break: keep-all;
    }
  }

  &__notice {
    background: #f5f5f7;
    padding: 32px 9px 42px 9px;

    .title {
      font-family: "GmarketSansBold";
      font-weight: bold;
      color: #222;
      font-size: 15px;
      text-align: center;
    }

    .notices {
      margin-top: 12px;
      padding-left: 20px;
      li {
        font-size: 12px;
        margin-bottom: 20px;
        color: #000;
        word-break: keep-all;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &__submit {
    padding: 0 9px;
    margin-top: 20px;

    button {
      font-family: "GmarketSansBold";
      font-weight: bold;
      background: #f5a52d;
      border-radius: 8px;
      font-size: 20px;
      color: #fff !important;
      width: 100%;
      height: 60px;
      line-height: inherit;
      display: flex;
      align-items: center;
      justify-content: center;

      &:disabled {
        background: #f0f0f0 !important;
      }
    }
  }
}
</style>
